(function () {
    'use strict';

    angular
        .module('app')
        .directive('popuphere', popuphere);

    popuphere.$inject = ['$window'];

    function popuphere($window) {
        // Usage:
        //     <popuphere></popuphere>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'E',
            scope: {
                show: '=',
                close: '&onClose'
            },
            replace: true,
            transclude: true,
            templateUrl: 'app/common/templates/popuphere.html'
        };
        return directive;

        function link(scope, element, attrs) {
            scope.dialogStyle = {};
            if (attrs.width)
                scope.dialogStyle.width = attrs.width;
            if (attrs.height)
                scope.dialogStyle.height = attrs.height;

            scope.hideModal = function () {
                scope.show = false;
            };
        }
    }

})();